import axios from 'axios';
import { getTenantSlug } from './tenant';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth token and tenant header to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Add tenant slug header for multi-tenancy
  // Skip for registration/public routes
  const publicRoutes = ['/auth/register', '/auth/login', '/public'];
  const isPublicRoute = publicRoutes.some(route => config.url?.includes(route));
  
  if (!isPublicRoute) {
    const tenantSlug = getTenantSlug();
    if (tenantSlug) {
      config.headers['X-Tenant-Slug'] = tenantSlug;
    }
  }
  
  return config;
});

// Handle auth errors - redirect to tenant-scoped login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // A 401 from a sign-in request means wrong credentials, not an expired session:
    // let the login form show the error instead of redirecting/reloading.
    const url = error.config?.url || '';
    const isLoginRequest = /\/(auth\/login|super-admin\/login)\b/.test(url);
    if (error.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Redirect to tenant-scoped login if tenant exists
      const tenantSlug = getTenantSlug();
      if (tenantSlug) {
        window.location.href = `/${tenantSlug}/login`;
      } else {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;